// src/features/medicalSercices/page/providerTypeForm.tsx

import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import DynamicForm, { type DynamicFormSchema } from '@/common/components/DynamicForm/DynamicForm';

export default function providerTypeForm() {
    const providerTypeFormSchema: DynamicFormSchema = {
        layout: 'vertical', // Overall form layout
        // submitButtonText: 'Save User', // Custom text for the submit button
        showResetButton: true, // Show a reset button

        // Define form sections for better organization and complex layouts
        sections: [
            {
                key: 'provider-type-section',
                title: 'Provider Type Details',
                type: 'card',
                layout: { type: 'grid', gutter: 24 },
                fields: [
                    {
                        name: 'name',
                        label: 'Name',
                        type: 'input',
                        colSpan: 24,
                        required: true,
                        validation: [
                            { max: 100, message: 'Name cannot exceed 100 characters.' }
                        ],
                        pattern: 'AlphaNumericWithSpaceHyphenApostropheAmpersandCommaDotSlashBrackets'
                    },
                    {
                        name: 'description',
                        label: 'Description',
                        type: 'textarea',
                        colSpan: 24,
                        validation: [
                            { max: 255, message: 'Description cannot exceed 255 characters.' }
                        ],
                        pattern: 'Description' // backend uses this regex
                    }
                    //{
                    //    name: 'status',
                    //    label: 'Status',
                    //    type: 'select',
                    //    required: true,
                    //    colSpan: 12,
                    //    pattern: 'OnlyDigits', // backend expects digit-only value
                    //    dynamicOptions: {
                    //        url:"/Lookup/GetDropdownData",
                    //        method: "POST",
                    //        body: { dropdowns: ["status"] },
                    //        transformData: "(res) => res.status.map(item => ({ label: item.name, value: item.id }))"
                    //    }
                    //}
                ]
            }
        ]
    };

    return (
        <DynamicForm
            schema={providerTypeFormSchema}
            submitApiUrl={API_ENDPOINTS.PROVIDERS.SAVE_PROVIDERTYPE}
            getByIdApiUrl={API_ENDPOINTS.PROVIDERS.GET_PROVIDERTYPE_BY_ID}
            updateApiUrl={API_ENDPOINTS.PROVIDERS.UPDATE_PROVIDERTYPE}
            refreshTableDataKey={QUERY_KEYS.PROVIDERS.PROVIDERTYPE}
        />
    );
}





